import React, { useEffect } from 'react';
import { CollapseBlock, Spinner } from '../../../../common';
import PermissionsTable from './PermissionsTable.jsx';
import { routes } from '../../../../../utils/helpers/ApiClient';
import { AppBarCMS } from '../../../../basic';
import { useTranslation } from 'react-i18next';
import {
  useDeletePermissionMutation,
  useGetPermissionsQuery,
} from '../../../../../redux/services/permissions';
import { useToastMessages } from '../../../../../hooks/useToastMessages';

export function PermissionsPage() {
  const { t } = useTranslation();

  const { deleteSuccess: showDeleteSuccess } = useToastMessages();

  const { data: permissions, refetch } = useGetPermissionsQuery();
  const [deletePermission] = useDeletePermissionMutation();

  useEffect(() => {
    document.title = t('Role') + ' - FRI CMS';
  }, []); // Runs on mount

  const handleDelete = ({ id }) => {
    deletePermission(id)
      .unwrap()
      .then(() => {
        showDeleteSuccess();
        refetch();
      });
  };

  if (!permissions) {
    return <Spinner />;
  }

  return (
    <>
      <AppBarCMS
        title={t('Oprávnenia')}
        backUrl={routes.cmsDashboard}
        backUrlTooltip={t('Nástenka')}
        permissionsBasic={'permissions'}
      />
      <div style={{ margin: '10px' }}>
        <CollapseBlock>
          <PermissionsTable permissions={permissions} onDelete={handleDelete} />
        </CollapseBlock>
      </div>
    </>
  );
}

export default PermissionsPage;
